import {ApiService} from "./api.service";

const userService = {
    login: ({email, password}) => {
        return new Promise(function (resolve, reject) {
            ApiService.post('/login', {email: email, password: password}).then((res) => {
                console.log(res.data);
                // debugger;
                if (res.data.status !== 200)
                    reject(res.data.message);

                let token = res.data.token;
                resolve(token);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    authorize: () => {
        return new Promise(function (resolve, reject) {
            ApiService.get('/intent?key=hello').then((res) => {

                let intents = res.data;
                resolve(intents);
            }).catch((error) => {
                reject(error.message);
            });
        });
    },
    getIntents: (gid) => {
        let url = "/intents";
        if (gid) url += "?group_id=" + gid;
        return new Promise(function (resolve, reject) {
            ApiService.get(url).then((res) => {


                if (res.data.status !== 200) {
                    reject(res.data.message);
                }


                let intents = res.data.intents;
                resolve(intents);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    getGroups: () => {
        return new Promise(function (resolve, reject) {
            ApiService.get('/groups').then((res) => {


                if (res.data.status !== 200) {
                    reject(res.data.message);
                }


                let intents = res.data.groups;
                resolve(intents);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    getIntent: (key) => {
        return new Promise(function (resolve, reject) {
            ApiService.get(`/intent?key=${key}`).then((res) => {
                console.log(res.data);
                // debugger;
                if (res.data.status !== 200) {
                    reject(res.data.message);
                }
                let intents = res.data;
                resolve(intents);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    createGroup: (group_name) => {
        return new Promise(function (resolve, reject) {
            ApiService.get(`/group/create/${group_name}`).then((res) => {
                console.log(res.data);


                if (res.data.status !== 200) {
                    res.data.message = "Error Creating Group";
                    reject(res.data.message);
                }

                let ret = res.data;
                delete ret.status;
                resolve(ret);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    getGroupIntent: (group_id) => {
        return new Promise(function (resolve, reject) {
            ApiService.get(`/intents?group_id=${group_id}`).then((res) => {
                console.log(res.data);


                if (res.data.status !== 200) {
                    res.data.message = "Error fething Group intents";
                    reject(res.data.message);
                }

                let ret = res.data;
                resolve(ret);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    getUtterance: (query) => {
        return new Promise(function (resolve, reject) {
            ApiService.get(`/testparse?q=${query}`).then((res) => {
                console.log(res.data);


                if (res.data.status !== 200) {
                    res.data.message = "Error fetching utterance";
                    reject(res.data.message);
                }
                if (res.data.intent===null) {
                    res.data.message = "No intent found";
                    reject(res.data.message);
                }

                let ret = res.data.intent;
                resolve(ret);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    createIntent: (name) => {
        return new Promise(function (resolve, reject) {
            ApiService.post(`/save`, {
                key: null,
                utterances: [],
                json: [],
                name: name,

            }).then((res) => {
                console.log(res.data);


                if (res.data.status !== 200) {
                    res.data.message = "Error Creating Group";
                    reject(res.data.message);
                }
                resolve(res.data);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    createGroupIntent: (name, id) => {
        return new Promise(function (resolve, reject) {
            ApiService.post(`/save`, {
                key: null,
                utterances: [],
                json: [],
                name: name,
                group_id: id,

            }).then((res) => {
                console.log(res.data);


                if (res.data.status !== 200) {
                    res.data.message = "Error Creating Group";
                    reject(res.data.message);
                }
                resolve(res.data);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    deleteUtterances: (key, name) => {
        return new Promise(function (resolve, reject) {
            ApiService.delete(`/utterance`, {key: key, text: name}).then((res) => {
                console.log(res.data);
                if (res.data.status !== 200) {
                    //  res.data.message = "Error ";
                    reject(res.data.message);
                }
                resolve(res.data);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    deleteIntent: (key) => {
        return new Promise(function (resolve, reject) {
            ApiService.delete(`/intent`, {key: key}).then((res) => {
                console.log(res.data);
                if (res.data.status !== 200) {
                    //  res.data.message = "Error ";
                    reject(res.data.message);
                }
                resolve(res.data);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    deleteGroup: (key) => {
        return new Promise(function (resolve, reject) {
            ApiService.delete(`/groups/${key}`).then((res) => {
                console.log(res.data);
                if (res.data.status !== 200) {
                    //  res.data.message = "Error ";
                    reject(res.data.message);
                }
                resolve(res.data);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    saveIntents: (key, utterances, json, name, group_id = null) => {
        let payload = {key: key, utterances: utterances, json: json, name: name}
        if (group_id) payload.group_id = group_id;
        return new Promise(function (resolve, reject) {
            ApiService.post(`/save`,payload).then((res) => {
                console.log(res.data);


                if (res.data.status !== 200) {
                    res.data.message = "Error Saving Group";
                    reject(res.data.message);
                }

                let ret = res.data;
                delete ret.status;
                resolve(ret);
            }).catch((error) => {

                reject(error);
            });
        });
    },
    // handleJwt: () => {
    //     window.sessionStorage.clear();
    //     Route.push({name: 'login'});
    // }

};

export {userService};
